// import { http_v2 } from '@api/client';
import { http } from '@api/client';
import { pickResponse, pickResult, paramterize } from '@api/utils';
import { ContentDetail } from '@lib/content';
import {
  ContentResult,
} from './content-genres-api.types';
import { of } from 'rxjs';
import { BaseResponse } from '@api/shared';
import { tap } from 'rxjs/operators';

/**
 * Get the deal details from the server.
 * @param vtr_id The id of the deal to get
 */
 export function get() {
  return http.get<ContentResult>(`/content/genres`).pipe(pickResponse());
  // return of(singleDealResponse);
}